export enum DefinitionLevel {
System,
Library,
Installation,
}
